import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const AppBanners = lazy(() => import('../../pages/AppBanners/AppBannersPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<AppBanners />} />
    </Routes>
  );
}

export default PagesRoute;
